import { render, staticRenderFns } from "./LoopsStatusBar.vue?vue&type=template&id=bf4bd9d6&scoped=true&"
import script from "./LoopsStatusBar.vue?vue&type=script&lang=js&"
export * from "./LoopsStatusBar.vue?vue&type=script&lang=js&"
import style0 from "./LoopsStatusBar.vue?vue&type=style&index=0&id=bf4bd9d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf4bd9d6",
  null
  
)

export default component.exports